export const EVALUATION_TEXT = {
  TITLE: 'Evaluation',
  CANDIDATE_STATEMENT_SCORE: 'Candidate Statement Scores',
  PANEL_AGREEMENT:
    'On behalf of the interview panel, it is agreed that the report is completed by the panel chair.',
  INTERVIEW_ASSESSMENT: 'Interview Assessment',
  INTERVIEW_MODE: 'Interview Mode',
  INTERVIEW_LANGUAGE: 'Interview Language',
  INTERVIEW_DATE: 'Interview Date',
  COMMENT: 'Comment',
  COMMENT_EG: 'Comment Example',
  COMMENT_GUIDELINE: 'Comment Guideline',
  EDIT_HISTORY: 'Edit History',
  SAVE_AT: 'Saved at',
  FUNDING_SCORES: 'Score(s) for Selected Funding Scheme(s)',
  SYSTEM_SCORES: 'UPAF Sub-scores',
  HKPFS_SUB_SCORES: 'HKPFS Sub-scores',
  PANEL_SELECTION: 'Panel Type',
  DISTINCTIVE_QUALITY: 'Distinctive Quality',
  ALERT_INFO: {
    UPDATE_PANEL_SUCCESS: 'Panel Selection has been updated successfully.',
    UPDATE_COMMENT_SUCCESS: 'Comment has been updated successfully.',
    UPDATE_RESEARCH_SUCCESS:
      'Research Assessment has been updated successfully.',
    UPDATE_DIMENSION_SUCCESS:
      'Dimensional Scores has been overwrote successfully.',
    UPDATE_INTERVIEW_SUCCESS:
      'Interview Panel Assessment has been updated successfully.',
    CHECK_ELIGIBILITY_SUCCESS: 'Eligibility has been checked successfully.',
    UPDATE_ACADEMIC_PROGRAMME_SUCCESS:
      'Academic Programme has been updated successfully.',
    CALCULATE_TOTAL_SCORES_SUCCESS: 'Scores has been calculated successfully. ',
  },
  S_PANEL: 'Science Panel',
  H_PANEL: 'Humanities Panel',
  ACADEMIC_EXCELLENCE: 'Academic Excellence',
  STRENGTHS: 'Strengths',
  LLM_GENERATED:
    "*The textual comments are currently assessed using LLMs, which inevitably leads to inaccuracies. However, the assessment results are merely as a reference, and the final scores can still be modified. Besides, this year's assessment results and feedback will be collected and used to fine-tune the LLMs, aiming for more accurate results in the future.",
  SUPERVISOR_HEADLINE:
    'This page gives an overview of scores for selected funding scheme(s), including total score(s) and detailed sub-scores. Please evaluate the applicant and provide your comments on Academic Excellence and Research Potential. Once the comments are submitted, AI-generated reference scores will be available for your review. ',
  UNIVERSITY_NAME: 'University Name',
  UNIVERSITY_INFO: 'University Info',
  GPA: 'Calculated GPA',
  ORIGIN_GPA: 'Original GPA',
  UL: 'UL',
  ACADEMIC_DIMENSION_TOOLTIP:
    'This dimension shows the academic achievement of the candidate, with comments data as possible bonus. ',
  ACADEMIC_PERFORMANCE: 'Academic Performance',
  LEADERSHIP_ABILITY: 'Leadership Ability and Societal Responsibility',
  RESILIENCE_CAPABILITY: 'Resilience Capability',
  CULTURE_DIVERSITY: 'Cultural Diversity',
  RESEARCH_POTENTIAL: 'Research Ability and Potential',
  COMMUNICATION: 'Communication and Interpersonal Skills',
  ORGANIZATION: 'Organization Skills',
  UNIVERSITY_SUPPORT: 'University Support',

  JOURNAL_NAME: 'Name of Journal / Conference / Publisher: ',
  JOURNAL_TYPE: 'Type: ',
  SYSTEM_SCORE: 'System Score',
  JUSTIFICATION:
    'Justification for the modified score (please specify which aspect(s)): ',
  EDITED_JUSTIFICATION: 'Edited Justification',
  OVER_WRITE: 'Overwrite',
  HEAD_HELPER_TEXT: {
    SUPERVISOR_HELPER_TEXT:
      'Please evaluate the applicant and provide your comments on Academic Excellence and Research Ability and Potential. Once the comments are submitted, AI-generated reference scores will be available for your review. If you have any questions regarding scores under Academic Excellence and Research Ability and Potential, you may modify them and provide justifications.',
    INTERVIEW_PANEL_HELPER_TEXT:
      'Please evaluate the applicant and provide your comments on Strengths and Distinctive Quality. Once the comments are submitted, AI-generated reference scores will be available for your review. If you have any questions regarding comments and scores under Academic Excellence, Research Ability and Potential, Strengths and Distinctive Quality, you may modify them and provide justifications. ',
    DORPG_HELPER_TEXT:
      "Please review all information and confirm the applicant's eligibility for nomination to GS for selected funding schemes.",
    POLISH_COMMENTS_HELPER_TEXT:
      'Please paraphrase the comments in accordance with the feedback provided by the Panel.',
  },
  DORPG_CONFIRMATION:
    'I have verified the studentship year(s) inputted by the chief supervisor and I confirmed that this applicant is eligible for nomination to GS for the above selected funding schemes. Inaccurate information will risk disqualification (Please return the application to the chief supervisor for revision if inaccurate information is submitted). Inaccurate information will risk disqualification.*',
  GEN_AI_HINT: 'Generating AI Score, Please Wait...',
  WRITING_COMMENTS:
    'In writing comments for each attribute, please cover the aspects and its keywords which are shown in the ',
  QUALIFICATION_RECOMMENDATION: `Please select the below funding scheme(s) for nomination to GS. Please click the “CONFIRM” and “SUBMIT” buttons. DoRPgS is required to prioritise all competitive schemes, except HKPFS. To prioritise the nominations, please click “Prioritise Nominations” on the home page, please be reminded to submit the prioritisation to GS before the respective nomination deadline. <br>
  To return or reject the application, please click the “Return / Reject” button on the dashboard. The system will redirect you to the DoRPgS Assessment Section, you can click the dropdown list to make your decisions in item 1a. 
  `,
  MONITOR_DORPG_ENDORSE:
    "The selected funding schemes from the list below have been recommended by DoRPgS, confirming the applicant's eligibility for nomination to GS. ",
  ACADEMIC_PROGRAMME_CATEGORY: 'Academic Programme Category (APC)',
  ACADEMIC_CATEGORY_A: 'A - Medicine & Dentistry',
  ACADEMIC_CATEGORY_B: 'B - Engineering & Lab-based Studies',
  ACADEMIC_CATEGORY_C: 'C - Others',
  SELECT_ACADEMIC_PROGRAMME_CATEGORY: `Please select the <a href = "https://www.polyu.edu.hk/gs/docdrive/staff/hkpfs/2024-25/Academic_Programme_Category_APC.pdf" target="_blank">Academic Programme Category (APC)</a>`,
  CALCULATE_SCORES_HELPER_TEXT:
    '*System will update the funding scores again if you click Calculate Scores Button. The Calculate Scores Button will be activated once finishing all the comments.',
  SAVE: 'Save',
  CLOSE: 'Close',
  CONFIRM: 'Confirm',
  CANCEL: 'Cancel',
  YES: 'Yes',
  CALCULATE_SCORES: 'Calculate Scores',
  NA: 'N/A',
  FUNDING_ELIGIBILITY_CONFIRM: 'Nomination to GS',
  OVERALL_AI: 'Scale: ',
  DEADLINE: 'Deadline: ',
  POLISH_COMMENTS: 'Polish Comments',
  PANEL_MEETING_REMARKS:
    'Remarks from HKPFS Panel Meeting to Department/School: ',
  POLISH_COMMENTS_CONFIRMATION_TITLE: 'Are you sure to polish the comments?',
  POLISH_COMMENTS_CONFIRMATION_SUCCESS:
    'Comments have been polished successfully. You will be redirected to the Polish Comments List.',
  SCORES_EXPLANATION:
    'The total score will be calculated after the interview panel has completed the evaluation of the strengths (and distinctive quality if applicable).',
};
